import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SESSION_PAYMENT_CLAIM_AND_FINISH_REQUEST = "API_SESSION_PAYMENT_CLAIM_AND_FINISH_REQUEST";
export const API_SESSION_PAYMENT_CLAIM_AND_FINISH_SUCCESS = "API_SESSION_PAYMENT_CLAIM_AND_FINISH_SUCCESS";
export const API_SESSION_PAYMENT_CLAIM_AND_FINISH_FAILURE = "API_SESSION_PAYMENT_CLAIM_AND_FINISH_FAILURE";

export const api_session_payment_claim_and_finish_request = (options) => {
	return {
		type: API_SESSION_PAYMENT_CLAIM_AND_FINISH_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_session_payment_claim_and_finish_success = (data) => {
	return {
		type: API_SESSION_PAYMENT_CLAIM_AND_FINISH_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_session_payment_claim_and_finish_failure = (error) => {
	return {
		type: API_SESSION_PAYMENT_CLAIM_AND_FINISH_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Session.apiSessionPaymentClaimAndFinish
*/
export const apiSessionPaymentClaimAndFinish = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_session_payment_claim_and_finish_request(options));
			const url=getAPIUrl([
				{"url": "/api/session/payment/claim_and_finish", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_session_payment_claim_and_finish_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_session_payment_claim_and_finish_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
